import { render, staticRenderFns } from "./CollectionBox.vue?vue&type=template&id=05853608&scoped=true"
import script from "./CollectionBox.vue?vue&type=script&lang=js"
export * from "./CollectionBox.vue?vue&type=script&lang=js"
import style1 from "./CollectionBox.vue?vue&type=style&index=1&id=05853608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05853608",
  null
  
)

export default component.exports